/**
 * The user-facing type.
 * If your form collects more fields, add them here.
 */
interface InputData {
    username: string;
    categories: string | string[];
    bio: string;
    profile_image: string;
    portfolio_links: string[];
    skills?: string[] ;
    social_links?: string[];
  }
  
  /**
   * Takes user input (from the form) and transforms it into the final payload
   * for your backend. Ensures certain fields are arrays and sets default
   * values for required fields not shown in the UI (like coffee_call values).
   */
  export function organizeData(data: InputData): Record<string, any> {
    // Make a shallow copy so we don’t mutate the original
    const result = { ...data };
  
    // Ensure `categories` is always an array
    if (typeof result.categories === "string") {
      result.categories = [result.categories];
    }
  
    // Add default backend-required fields
    (result as any).contact_preferences = "Email"; // Example default
    (result as any).coffe_call_enabled = true;     // Example default
    (result as any).coffe_call_price = 10;         // Example default
    (result as any).coffe_call_duration = 30;      // Example default (minutes)
    (result as any).coffe_call_availability = "Scheduled"; // Example default
  
    return result;
  }
  